import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

export default function useNewTranslation() {
  const translationer = useTranslation();

  const newT = useCallback((key: string, options?: any) => {
    return translationer.t(key, options).replace(/\\n/g, '\n');
  }, [translationer])

  return {
    ...translationer,
    t: newT
  }
}
